<template>
  <div
    :class="[
      {
        clickable: !readOnly,
        'marked-incorrect': item.isMarkedIncorrect,
      },
    ]"
  >
    <m-layout-stack horizontal>
      <div>
        <span>Over-the-counter medication: {{ getMainLine }}</span>
        <span v-if="item.startDateIsNotEncounterDate || item.startDateIsNotDocumentDate">
          • Started {{ item.startDate }}</span
        >
        <span v-if="item.isEnded"> • Ended {{ item.endDate ?? "" }}</span>
        <span v-if="item.additionalInformation"> • {{ item.additionalInformation }} </span>
      </div>
      <i v-if="item.isRetrospectivelyAmended" style="white-space: nowrap">{{
        formatRetrospectivelyAmendedLabel
      }}</i>
    </m-layout-stack>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

export type MedicationStatementOverTheCounterJournalItem = {
  isEnded: boolean;
  dosageInstruction: string;
  linkedProblems: { problemCodeDescription: string }[];
  confidentialFromThirdParties: boolean;
  hiddenFromPatientFacingServices: boolean;
  isMarkedIncorrect: boolean;
  productName: string;
  isRetrospectivelyAmended: boolean;
};

const props = defineProps<{
  item: MedicationStatementOverTheCounterJournalItem;
  readOnly: boolean;
  contextHiddenFromPatientFacingServices?: boolean;
  contextConfidentialFromThirdPartyServices?: boolean;
}>();

const formatRetrospectivelyAmendedLabel = computed(() => {
  let label = [];
  if (props.item.isRetrospectivelyAmended) {
    label.push("Edited");
  }

  return label.join(" • ");
});

const getMainLine = computed(() => {
  const textAsArray = [props.item.productName, props.item.dosageInstruction];
  const text = textAsArray.filter((x) => x).join(" • ");
  return text === "" ? false : text;
});
</script>
